import { useEffect, useState } from "react";

const DISMISS_KEY = "sg:install-banner:dismissed";
const DOWNLOAD_URL = "https://ventrin.com/download.html";

export function InstallBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => { setDismissed(localStorage.getItem(DISMISS_KEY) === "1"); }, []);

  if (dismissed) return null;

  return (
    <div className="sg-install-strip">
      <div style={{ flex: 1 }}>
        <div className="sg-install-title">
          Activate Ventrin Protection
        </div>
        <div className="sg-muted" style={{ fontSize: 12.5, lineHeight: 1.55 }}>
          Install the browser extension to begin intercepting prompts to ChatGPT, Claude, Gemini, and Copilot in real time.
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, flexShrink: 0 }}>
        <a
          className="sg-btn sg-btn-primary sg-btn-sm"
          href={DOWNLOAD_URL}
          target="_blank"
          rel="noopener"
          style={{ textAlign: "center" }}
        >
          Download for Chrome
        </a>
        <button className="sg-btn sg-btn-ghost sg-btn-sm" onClick={() => {
          localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true);
        }}>Dismiss</button>
      </div>
    </div>
  );
}
